import { Link } from 'react-router';
import { Workspace } from './Workspace';

export function NotFound() {
  return (
    <Workspace title="Not found">
      <article className="page">
        <h1>Paste not found</h1>
        <p>
          It may have been deleted. <Link to="/">Create a new paste</Link>
        </p>
      </article>
    </Workspace>
  );
}
